import { Alert, Button, Center, Loader, Stack } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSession } from '../lib/session';

/**
 * Where Zitadel sends the browser back. The code in the URL is exchanged for
 * the tokens and the console takes over from `/`.
 */
export function AuthCallbackPage() {
  const { completeSignIn } = useSession();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  // Once: strict mode mounts twice, and an authorization code is good for one
  // exchange.
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    completeSignIn()
      .then(() => navigate('/', { replace: true }))
      .catch((err) => setError(err instanceof Error ? err.message : String(err)));
  }, [completeSignIn, navigate]);

  return (
    <Center h="100vh">
      {error ? (
        <Stack align="center">
          <Alert color="red" variant="light" role="alert" title="Sign-in failed">
            {error}
          </Alert>
          <Button variant="default" onClick={() => navigate('/', { replace: true })}>
            Back
          </Button>
        </Stack>
      ) : (
        <Loader />
      )}
    </Center>
  );
}
